import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import { Button } from 'antd';
/**
 * 环节办理详情查询列表
 * @author Xiafanglin
 * @date 2018-03-20 08:14:03
 * Version: 1.0
 */
class HjblxqcxIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
            }
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //导出Excel文件  
    handleExportBtnClick = () => {
        this.refs.nhTable.exportExcel("导出环节办理详情数据");
    };

    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '51px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                search: 'input',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XSXM',
                width: '91px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '72px',
                search: 'input',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '校区',
                width: '101px',
                search: 'input',
                dataIndex: 'XQMC',
                searchType:"select"
            }, {
                title: '院系',
                width: '200px',
                search: 'input',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                search: 'input',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                search: 'input',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
              title: '所属流程',
              width: '120px',
              search: 'input',
              dataIndex: 'SSLC',
              searchType:"select"
            }, {
                title: '环节名称',
                width: '120px',
                search: 'input',
                dataIndex: 'HJMC',
                searchType:"select"
            }, {
                title: '环节类型',
                width: '120px',
                search: 'input',
                dataIndex: 'HJLX',
                searchType:"select"
            }, {
                title: '办理状态',
                width: '120px',
                search: 'input',
                filters: [{ text: '已办理', value: '已办理' }, { text: '未办理', value: '未办理' }],
                dataIndex: 'BLZT',
                searchType:"select"
            }, {
                title: '办理人',
                width: '100px',
                search: 'input',
                dataIndex: 'BLR',
                searchType:"input"
            }, {
                title: '办理时间',
                width: '150px',
                search: 'input',
                dataIndex: 'BLSJZS',
                commonSearch:false,
                searchType:"date"
            }
        ];

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>
                    <NHTable
                        ref='nhTable'
                        sign={"zhxg_yxxt_tjcx_hjblxqcx_queryPage"}
                        columns={columns}
                        rangeFilter={true}
                    >
                        <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.handleExportBtnClick}>导出</Button>
                    </NHTable>
                </div>
            </div>
        );
    }
}
export default HjblxqcxIndex;



// WEBPACK FOOTER //
// ./components/tjcx/hjblxqcx/index.js